import { NgModule } from '@angular/core';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { UsersComponent } from './users.component';
import { ViewComponent } from './view/view.component';


const routes: Routes = [
    { path: '', component: UsersComponent },
    { path: ':user', component: ViewComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class UsersRoutingModule { }
